export class MeterReadingEmailRecibos {
    constructor(
        public email: string,
        public operationId: string,
        public nextDate: string,
        public operationNumber: string,
        public imageBase64: string
    ) { }
}